import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import './report.css';

export class AllProjectsCosts extends Component {
    columns = [
        { title: 'Проект', field: 'name' },
        { title: 'SP', field: 'sp' },
        { title: 'План', field: 'planHours' },
        { title: 'Факт', field: 'time' },
        { title: 'Премия', field: 'profit' },
        { title: 'Стоимость часа', field: 'hourCost' },
        { title: 'СТоимость SP', field: 'spCost' },
    ];

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.loadReport = this.loadReport.bind(this);
    }

    componentDidMount() {
        this.loadReport();
    }

    loadReport() {
        var scope = this;
        scope.setState({ loading: true});
        
        fetch('api/Report/GetCosts', {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ costs: result, loading: false });

                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        return (
            <div>
                <h3>Инфа по проектам</h3>
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <MaterialTable
                    title=""
                    columns={this.columns}

                    data={this.state.costs}
                    editable={{
                    }}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Редактировать',
                            isFreeAction: false,
                            onClick: (event, rowData) => {
                                this.handleScheduleEdit(rowData);
                            }
                        },
                    ]}
                />}
            </div>
        )
    }
}